export default "__VITE_ASSET__BborBcPK__"